import CorporationsConfig from './CorporationsConfig';
import SoleConfig from './SoleConfig';
import LlcConfig from './LlcConfig';
import LlpConfig from './LlpConfig';
import PartnershipConfig from './PartnershipConfig';

const UploadsConfig = [
    CorporationsConfig, 
    CorporationsConfig, 
    SoleConfig, 
    LlcConfig, 
    LlpConfig, 
    CorporationsConfig,
    PartnershipConfig,
];

export default UploadsConfig;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/articles/UploadsConfig/UploadsConfig.js